/**
 * 
 * @param {Object} document 
 * @param {Function} linkResolver 
 * @param {Array} prismicLocalesToInclude 
 * @param {Map} prismicToHrefLangMap 
 * @returns {Array}
 */
export default function getHrefLangs(document, linkResolver, prismicLocalesToInclude = null, prismicToHrefLangMap = null) {

    let alternateDocuments = document.alternate_languages;
    
    // filter if we have prismicLocalesToInclude
    if (prismicLocalesToInclude !== null) {
        alternateDocuments = alternateDocuments.filter(alternate => 
            prismicLocalesToInclude.includes(alternate.lang)
        );
    }

    return alternateDocuments.map(alternate => {
        return getHrefLang(alternate, linkResolver, prismicToHrefLangMap);
    }).concat(getHrefLang(document, linkResolver, prismicToHrefLangMap));

}

function getHrefLang(document, linkResolver, prismicToHrefLangMap = null) {

    let hreflang = null;

    if (prismicToHrefLangMap !== null) {
        hreflang = prismicToHrefLangMap.get(document.lang);
    }

    return {
        rel: 'alternate',
        href: linkResolver(document, true),
        hreflang: hreflang ? hreflang : document.lang
    };
}